import React, { useEffect, useState } from 'react'
import moment from 'moment'

import { TextField as MuiTextField } from '@material-ui/core'

import { FilterProps } from './types'

export const DateFilter = (props: FilterProps) => {
  const { label, defaultValue, onChange } = props
  const [value, setValue] = useState<moment.Moment>(defaultValue)

  useEffect(() => {
    if (!defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  return (
    <MuiTextField
      type="date"
      id={label}
      variant="standard"
      label={label}
      fullWidth
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = moment(e.target.value)
        setValue(newValue)
        onChange(newValue, newValue ? newValue.format('YYYY-MM-DD') : '')
      }}
      value={value ? value.format('YYYY-MM-DD') : ''}
    />
  )
}
